import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-wind-low",
  "use": "icon-wind-low-usage",
  "viewBox": "0 0 16 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 6\" id=\"icon-wind-low\"><path d=\"M15.522 1.981c.365 2.168-.8 3.115-1.4 3.066-.6-.05-1.071-.77-2.465-1.073-1.393-.303-2.502.32-2.39-1.053l.049-.12s5.002-4.044 6.206-.82zm-11.283.6c1.348.366 2.4-.243 2.327 1.183l-.045.123S1.813 7.914.574 4.514c-.407-2.269.69-3.212 1.269-3.139.578.073 1.049.84 2.396 1.206zm4.906 2.403a2.024 2.024 0 1 1-2.322-3.316 2.024 2.024 0 0 1 2.322 3.316z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol